module.exports = __webpack_public_path__ + "static/media/leader_notes_detailed.a3f6137b.pdf";